import styled from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, styled.div`
  color: ${({ white }) => (white ? theme.colors.white : theme.colors.black)};
  display: flex;
  flex-wrap: wrap;
  padding: ${theme.unit}px;
  margin: -${theme.unit * 2}px;

  & > div {
    flex: ${({ grow = true }) => (grow ? 1 : 0)};
    flex-basis: ${({ width }) => width || '250px'};
    margin: ${theme.unit}px;

    ${({ minWidth }) => minWidth && `
      min-width: ${minWidth}px;
    `}
  }

  ${({ small }) => small && `
    padding: ${theme.unit / 2}px;
    margin: -${theme.unit}px;

    & > div {
      margin: ${theme.unit / 2}px;
    }
  `}
`);



// WEBPACK FOOTER //
// ./src/components/blocks/Blocks.js